// frontend/src/constants/injuryRisk.ts

export const TIER_CONFIG: Record<string, { label: string; color: string }> = {
  LOW: { label: 'Low', color: '#22c55e' },
  MODERATE: { label: 'Moderate', color: '#eab308' },
  ELEVATED: { label: 'Elevated', color: '#f97316' },
  HIGH: { label: 'High', color: '#ef4444' },
  CRITICAL: { label: 'Critical', color: '#991b1b' },
};

export const TIER_ORDER = ['CRITICAL', 'HIGH', 'ELEVATED', 'MODERATE', 'LOW'];
export const ELEVATED_TIERS = new Set(['ELEVATED', 'HIGH', 'CRITICAL']);
